
import {Component, Vue} from "vue-property-decorator";
import {AuthService} from "@/services/auth";
import TopNavBar from "@/components/navigation/top-navbar.vue";

@Component({
    components: {
        TopNavBar
    }
})
export default class App extends Vue {
    initialized = false;

    async mounted() {
        await AuthService.init();
        this.initialized = true;
    }
}
